import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AppointmentWizardComponent } from './pages/appointment-wizard/appointment-wizard.component';
import { ProfessionalListComponent } from './components/professional-list/professional-list.component';
import { ProfessionalItemComponent } from './components/professional-item/professional-item.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { TimeListComponent } from './components/time-list/time-list.component';
import { TimeItemComponent } from './components/time-item/time-item.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { PaymethodListComponent } from './components/paymethod-list/paymethod-list.component';
import { PaymethodItemComponent } from './components/paymethod-item/paymethod-item.component';
import { PaymentWizardComponent } from '../../shared/components/wizard/payment-wizard/payment-wizard.component';
import { ServiceViewComponent } from './components/service-view/service-view.component';

@NgModule({
    declarations: [
        AppointmentWizardComponent,
        ProfessionalListComponent,
        ProfessionalItemComponent,
        CalendarComponent,
        TimeListComponent,
        TimeItemComponent,
        ConfirmComponent,
        PaymethodListComponent,
        PaymethodItemComponent,
        ServiceViewComponent,
    ],
    imports: [CommonModule, IonicModule, FormsModule, SharedModule],
    exports: [AppointmentWizardComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class AppointmentWizardModule {}
